// export const LOCALES = [{ locale: 'en-US', title: 'English' }];// { locale : 'zh-CN', title: '\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09'}
export const LONG_LOCALES = [
	{ locale: 'en-US', title: 'English'}
];
export const LOCALES = ['en_US'];
if (process.env.REACT_APP_CHANNEL_CODE === 'HK'){
	LONG_LOCALES.push(
		{ locale: 'zh-HK', title: '繁體中文'},
		{ locale: 'zh-CN', title: '简体中文'}
	);
	LOCALES.push('zh_HK', 'zh_CN');
}

export const LAUNCH_PARAM_STR = 'LAUNCH_PARAM_STR';
export const HIDDEN_LAUNCH_PARAM_STR = 'HIDDEN_LAUNCH_PARAM_STR';
export const ENTITY_KEY = 'ENTITY_KEY';
